const ticket = {
  createANewTicket: "Create a New Ticket",
  subject: "Subject",
  label: "Label",
  relatedEquipment: "Related Asset",
  notAnEquipment: "Not An Asset",
  description: "Description",
  submit: "Submit",
  yourTickets: "Your Tickets",
  issues: "Issues",
  mechanicalSupport: "Mechanical Support",
  suggestions: "Suggestions",
  ticketProfile: "Ticket Profile",
  status: "Status",
  comments: "Comments",
  comment: "Comment",
  addNewComment: "Add New Comment"
};

export default ticket;
